/* eslint-disable camelcase */
const FRIEND_SEAECH_TABLE_COL = [
  {
    displayName: "ID",
    key: "friendId",
  },
  {
    displayName: "Friend Name & Address",
    key: ["friendsName", "friendsAddress"],
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Organization Structure",
    key: "os",
  },

  {
    displayName: "Date of First Meeting",
    key: "meeting",
  },
  {
    displayName: "Action",
    key: "action",
  },
];

const REQUEST_TRANSFER_COL = [
  // {
  //   displayName: "Member ID",
  //   key: "memberId",
  // },
  {
    displayName: "Name & Address",
    key: ["fullName", "addressLine1"],
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Present Organization Strucuture",
    // colSpan: "5",
    key: ["districtName", "areaName", "zoneName", "chapterName"],
  },
  {
    displayName: "Action",
    key: "action",
  },
];

const REQUEST_TRANSFER_COL_2 = [
  // {
  //   displayName: "Member ID",
  //   key: "memberId",
  // },
  {
    displayName: "Member Name",
    key: ["phone", "email"],
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Present Organization Strucuture",
    colSpan: "6",
    key: ["districtName", "areaName", "zoneName", "chapterName"],
  },
];

const FRIEND_SEARCH_COL = [
  "createdAt",
  "updatedAt",
  "createdBy",
  "updatedBy",
  "friendId",
  "gender",
  "type",
  "fullName",
  "emailId",
  "mobileNumber",
  "addressLine1",
  "addressLine2",
  "city",
  "pincode",
  "state",
  "parentsEmailId",
  "parentsMobileNumber",
  "nationalityId",
  "divisionId",
  "divisionName",
  "subdivisionId",
  "subDivisionName",
  "introducedBy",
  "areaId",
  "areaName",
  "zoneId",
  "zoneName",
  "regionId",
  "regionName",
  "chapterId",
  "chapterName",
  "districtId",
  "districtName",
  "blockId",
  "blockName",
  "introducerName",
  "introducerEmail",
  "introducerMobileNumber",
  "dob",
  "introductionId",
  "profession",
  "present",
];

const FRIEND_TRANSFER_REQ_COL = [
  "createdAt",
  "updatedAt",
  "transferId",
  "friendId",
  "status",
  "fullName",
  "mobileNumber",
  "addressLine1",
  "state",
  "city",
  "pincode",
  "divisionId",
  "subdivisionId",
  "divisionName",
  "subDivisionName",
  "introducedByName",
  "introducedByEmail",
  "introducedByMobileNumber",
  "initiatorMember.fullName",
  "initiatorMember.mobileNumber",
  "initiatorMember.districtName",
  "initiatorMember.districtId",
  "initiatorMember.chapterName",
  "initiatorMember.chapterId",
  "initiatorMember.regionName",
  "initiatorMember.regionId",
  "initiatorMember.zoneName",
  "initiatorMember.zoneId",
  "initiatorMember.areaName",
  "initiatorMember.areaId",
  "targetOrganizationStructure.targetOrgDistrict",
  "targetOrganizationStructure.targetOrgDistrictId",
  "targetOrganizationStructure.targetOrgChapter",
  "targetOrganizationStructure.targetOrgChapterId",
  "targetOrganizationStructure.targetOrgRegion",
  "targetOrganizationStructure.targetOrgRegionId",
  "targetOrganizationStructure.targetOrgZone",
  "targetOrganizationStructure.targetOrgZoneId",
  "targetOrganizationStructure.targetOrgArea",
  "targetOrganizationStructure.targetOrgAreaId",
];

const VIEW_INTRO_COL = [
  "introductionId",
  "fullName",
  "mobileNumber",
  "addressLine1",
  "city",
  "pincode",
  "state",
  "nationalityId",
  "divisionId",
  "divisionName",
  "subdivisionId",
  "subDivisionName",
  "introducedByName",
  "introducedByEmail",
  "introducedByMobileNumber",
  "areaId",
  "areaName",
  "createdAt",
  "updatedAt",
  "createdBy",
  "updatedBy",
  "initiatorMember.fullName",
  "initiatorMember.mobileNumber",
  "initiatorMember.areaId",
  "initiatorMember.areaName",
  "initiatorMember.zoneId",
  "initiatorMember.zoneName",
  "initiatorMember.regionId",
  "initiatorMember.regionName",
  "initiatorMember.chapterId",
  "initiatorMember.chapterName",
  "initiatorMember.districtId",
  "initiatorMember.districtName",
  "targetOrganizationStructure.targetOrgArea",
  "targetOrganizationStructure.targetOrgAreaId",
  "targetSiName",
  "targetSiMobileNumber",
];

export {
  FRIEND_SEAECH_TABLE_COL,
  REQUEST_TRANSFER_COL,
  REQUEST_TRANSFER_COL_2,
  FRIEND_SEARCH_COL,
  FRIEND_TRANSFER_REQ_COL,
  VIEW_INTRO_COL,
};
